window.showAlert = function showAlert(type) {
    const alertContainer = document.getElementById('alertContainer');

    const alertMessages = {
        success: "This is a success alert—well done!",
        danger: "This is a danger alert—something went wrong!",
        info: "This is an info alert—check it out!",
        warning: "This is a warning alert—be careful!"
    };

    const alert = document.createElement('div');
    alert.className = `alert alert-${type} alert-dismissible fade show`;
    alert.role = 'alert';
    alert.innerHTML = `
        ${alertMessages[type]}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      `;

    alertContainer.appendChild(alert);

    setTimeout(() => {
        alert.classList.remove('show');
        alert.addEventListener('transitionend', () => alert.remove());
    }, 5000);
}

$(document).ready(function() {
    $(".shareSocial").jsSocials({
        shareIn: "popup",
        showLabel: false,
        showCount: false,
        shares: [
            {
                share: "facebook",
                logo: "/web_assets/images/facebook.svg"
            },
            {
                share: "twitter",
                logo: "/web_assets/images/twitter-x.svg"
            },
            {
                share: "linkedin",
                logo: "/web_assets/images/linkedin.svg"
            },
            {
                share: "pinterest",
                logo: "/web_assets/images/pinterest.svg"
            },
        ]
    });
});

/* Product preview counter, checkout counter */
document.querySelectorAll(".counterWrap").forEach((counterItem) => {
    const decrementBtn = counterItem.querySelector('.decrement');
    const incrementBtn = counterItem.querySelector('.increment');
    const counter = counterItem.querySelector('.counter');

    let count = parseInt(counter.textContent) || 1;

    if (incrementBtn) {
        incrementBtn.addEventListener('click', () => {
            count++;
            counter.textContent = count;
        });
    }
    if (decrementBtn) {
        decrementBtn.addEventListener('click', () => {
            if (count > 1) {
                count--;
            }
            counter.textContent = count;
        });
    }
});

// remove alert after 5s
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        let alerts = document.querySelectorAll(".alert");
        alerts.forEach(alert => {
            alert.classList.add("fade");
            setTimeout(() => alert.remove(), 500);
        });
    }, 5000);
});

// responsive menu
$('.hamburger').click(function (e) {
    e.preventDefault();
    $('body').toggleClass('active');
    $('.mobileMenu').slideToggle();
});

$('.mobileHamburger').click(function (e) {
    e.preventDefault();
    $('body').toggleClass('active');
    $('.mobileMenu').slideUp();
});

$('.mobileDropdownItem > a').click(function (e) {
    e.preventDefault();

    $(this).next('.mobileSubmenu').slideToggle();
    $('.mobileSubmenu').not($(this).next()).slideUp();
});

// checkout coupon selection
$('.couponCard').click(function (e) {
    e.preventDefault();

    $('.couponCard').removeClass('selected').removeAttr('data-selected');
    $(this).addClass('selected').attr('data-selected', 'true');
});

// registration add branches
const branchSelect = document.getElementById("registration_company_branch");
const container = document.getElementById("employeeInputs");

if (branchSelect) {
    function generateInputs(count) {
        const firstInput = container.querySelector(".form-group");

        container.innerHTML = "";
        if (firstInput) {
            container.appendChild(firstInput);
        }

        for (let i = 2; i <= count; i++) {
            const div = document.createElement("div");
            div.className = "form-group mb-3";
            div.innerHTML = `
                <label for="registration_company_employee${i}">Broj zaposlenih u poslovnici ${i}</label>
                <input type="text" class="form-control" name="registration_company_employee${i}" id="registration_company_employee${i}">
            `;
            container.appendChild(div);
        }
    }

    generateInputs(parseInt(branchSelect.value));

    branchSelect.addEventListener("change", function () {
        generateInputs(parseInt(this.value));
    });
}

// mobile language selection
$(".mobileLang a").click(function (e) {
    $(".mobileLang a").removeClass("active");
    $(this).addClass("active");
});

// user dashboard - checkbox modal select
document.querySelectorAll(".walletModalCard .form-check-input").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
        document.querySelectorAll(".walletModalCard").forEach((card) => card.classList.remove("active"));
        document.querySelectorAll(".walletModalCard .form-check-input").forEach((cb) => cb.checked = false);

        this.checked = true;
        this.closest(".walletModalCard").classList.add("active");
    });
});

// mobile menu open
/*document.addEventListener("DOMContentLoaded", function () {
    const userDropdown = document.getElementById("userDropdown");

    if (!userDropdown) return;

    const dropdownMenu = userDropdown.nextElementSibling;

    function isTouchDevice() {
        return window.matchMedia("(max-width: 992px)").matches;
    }

    userDropdown.addEventListener("click", function (event) {
        if (isTouchDevice()) {
            event.preventDefault();
            dropdownMenu.classList.toggle("show");

            document.querySelectorAll(".dropdown-menu").forEach(menu => {
                if (menu !== dropdownMenu) menu.classList.remove("show");
            });
        }
    });

    document.addEventListener("click", function (event) {
        if (isTouchDevice() && !userDropdown.parentElement.contains(event.target)) {
            dropdownMenu.classList.remove("show");
        }
    });

    window.addEventListener("resize", function () {
        if (!isTouchDevice()) {
            dropdownMenu.classList.remove("show");
        }
    });
});*/

document.addEventListener("DOMContentLoaded", function () {
    const dropdownToggles = document.querySelectorAll(".customDropdownToggle");

    if (dropdownToggles.length === 0) return;

    function isTouchDevice() {
        return window.matchMedia("(max-width: 992px)").matches;
    }

    dropdownToggles.forEach(toggle => {
        const dropdownMenu = toggle.parentElement.querySelector(".dropdown-menu");

        toggle.addEventListener("click", function (event) {
            if (isTouchDevice()) {
                event.preventDefault();
                dropdownMenu.classList.toggle("show");

                // Close other dropdowns
                document.querySelectorAll(".dropdown-menu").forEach(menu => {
                    if (menu !== dropdownMenu) menu.classList.remove("show");
                });
            }
        });

        document.addEventListener("click", function (event) {
            if (isTouchDevice() && !toggle.parentElement.contains(event.target)) {
                dropdownMenu.classList.remove("show");
            }
        });

        window.addEventListener("resize", function () {
            if (!isTouchDevice()) {
                dropdownMenu.classList.remove("show");
            }
        });
    });
});


$(document).ready(function () {
    function setEqualHeight() {
        let maxHeight = 0;

        $('.heroMealSliderItem').css('height', 'auto');

        $('.heroMealSliderItem').each(function () {
            let thisHeight = $(this).outerHeight();
            if (thisHeight > maxHeight) {
                maxHeight = thisHeight;
            }
        });

        $('.heroMealSliderItem').css('height', maxHeight + 'px');
    }

    setEqualHeight();

    $(window).resize(function () {
        setEqualHeight();
    });

    $('.heroMealSlider').on('setPosition', function () {
        setEqualHeight();
    });
});

$( function() {
    $( ".datepicker" ).datepicker({
        dateFormat: "dd.mm.yy",
        firstDay: 1,
        changeMonth: true,
        changeYear: true,
        yearRange: "1900:c",
        maxDate: 0,
        showAnim: "slideDown",
    });
} );

// product preview
document.addEventListener("DOMContentLoaded", function () {
    const helper = document.querySelector("#stickyHelper");
    const productPreviewTab = document.querySelector(".productPreviewTab");

    if (helper && productPreviewTab) {
        // sticky toggle
        const observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) {
                productPreviewTab.classList.add("stuck");
            } else {
                productPreviewTab.classList.remove("stuck");
            }
        });

        observer.observe(helper);
    }

    // scroll to top when tab is clicked
    const scrollTarget = document.querySelector(".productPreview");
    const tabLinks = document.querySelectorAll(".productPreviewTab .nav-link");

    if (scrollTarget && tabLinks.length > 0) {
        tabLinks.forEach(link => {
            link.addEventListener("shown.bs.tab", function () {
                const offset = 20;
                const top = scrollTarget.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({
                    top: top,
                    behavior: "smooth"
                });
            });
        });
    }
});
